import api from '../api'
let pending = null
let pendingToken = ''
export function token() {
  try {
    return localStorage.getItem('token') || ''
  } catch (e) {
    return ''
  }
}
export function employee(store) {
  if (store.state.profile) return Promise.resolve(store.state.profile)
  const current = token()
  if (pending && pendingToken === current) return pending
  pendingToken = current
  pending = api
    .post('/api/employee', {})
    .then(data => {
      if (current === token()) store.commit('setProfile', data)
      return data
    })
    .then(
      data => {
        pending = null
        return data
      },
      error => {
        pending = null
        throw error
      }
    )
  return pending
}
export function clearSession(store) {
  try {
    localStorage.removeItem('token')
  } catch (e) {}
  pending = null
  pendingToken = ''
  store.commit('resetSession')
}



// WEBPACK FOOTER //
// ./src/common/session.js